import { doc, getDoc, addDoc, collection, Timestamp, query, where, getDocs } from "firebase/firestore";
import { httpsCallable } from "@firebase/functions";
import { db, functions } from "../firebase";
export default function () {
  function urlHostname(url) {
    if (url) {
      const hostname = new URL(url).hostname;
      return hostname.replace(/^www\./, "");
    } else {
      return "";
    }
  }
  function shuffleArray(array) {
    var tmp,
      current,
      top = array.length;

    if (top)
      while (--top) {
        current = Math.floor(Math.random() * (top + 1));
        tmp = array[current];
        array[current] = array[top];
        array[top] = tmp;
      }

    return array;
  }

  function removeLeadingTrailingCommas(string) {
    return string.replace(/(^,)|(,$)/g, "");
  }

  function createFillString(string, fillWordsArray) {
    for (var needle of fillWordsArray) {
      string = string.replace(needle, "______");
    }
    return string.trim();
  }

  function userInitials(userName) {
    var names = userName.split(" "),
      initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    } else {
      initials = "You";
    }
    return initials;
  }

  async function getUser(userId) {
    const docRef = doc(db, "users", userId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      return false;
    }
  }

  function convertDateToUTC(date) {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  }

  function dateString(seconds, showYear = undefined) {
    const date = convertDateToUTC(new Date(seconds * 1000));

    const options = {
      year: showYear ? "numeric" : undefined,
      month: "short",
      day: "numeric",
      // hour: "numeric",
      // minute: "numeric",
      // second: "numeric",
    };
    return date.toLocaleString("en-US", options);
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function dateBounds(date) {
    const startOfTodayUtc = new Date(date).setUTCHours(0, 0, 0, 0);
    const endOfTodayUtc = new Date(date).setUTCHours(23, 59, 59, 999);
    const startUtc = Timestamp.fromDate(new Date(startOfTodayUtc));
    const endUtc = Timestamp.fromDate(new Date(endOfTodayUtc));

    const startOfToday = new Date(date).setHours(0, 0, 0, 0);
    const endOfToday = new Date(date).setHours(23, 59, 59, 999);

    const start = Timestamp.fromDate(new Date(startOfToday));
    const end = Timestamp.fromDate(new Date(endOfToday));

    return { start, end, startUtc, endUtc };
  }

  function sameDay(epoch1, epoch2) {
    return Math.floor(epoch1 / 86400) === Math.floor(epoch2 / 86400);
  }

  function minutesBetween(epoch1, epoch2) {
    return Math.floor((epoch2 - epoch1) / 60);
  }

  function extensionInstalled(id, src, callback) {
    let e = new Image();
    e.src = `chrome-extension://${id}/${src}`;
    (e.onload = () => callback(true)), (e.onerror = () => callback(false));
  }

  async function debugging(data) {
    try {
      await addDoc(collection(db, "debugging"), {
        createdAt: Timestamp.fromDate(new Date()),
        data,
      });
    } catch (error) {
      return;
    }
  }

  function getYouTubeEmbedUrl(url) {
    const videoId = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/)[2];
    return videoId ? `https://www.youtube-nocookie.com/embed/${videoId}` : null;
  }

  function daysBetweenDates(date1, date2) {
    const diff = date2.getTime() - date1.getTime();
    const dayDiff = Math.ceil(diff / (1000 * 60 * 60 * 24));
    return Math.abs(dayDiff);
  }

  const stripeCustomerPortal = async () => {
    const functionRef = httpsCallable(functions, "ext-firestore-stripe-subscriptions-createPortalLink");
    const { data } = await functionRef({
      returnUrl: window.location.href,
      locale: "auto",
    });
    return data.url;
  };

  const stripePrices = async () => {
    const productQuery = query(collection(db, "products"), where("active", "==", true));
    const productSnap = await getDocs(productQuery);
    for (const subscriptionDoc of productSnap.docs) {
      const pricesSnap = await getDocs(collection(subscriptionDoc.ref, "prices"));

      const prices = pricesSnap.docs.map((priceDoc) => {
        return {
          id: priceDoc.id,
          ...priceDoc.data()
        };
      });
      return prices;
    }
  };

  return {
    urlHostname,
    shuffleArray,
    removeLeadingTrailingCommas,
    createFillString,
    getUser,
    dateString,
    capitalizeFirstLetter,
    sameDay,
    extensionInstalled,
    dateBounds,
    debugging,
    userInitials,
    getYouTubeEmbedUrl,
    daysBetweenDates,
    stripeCustomerPortal,
    minutesBetween,
    stripePrices,
  };
}
